import type { Screen } from '@/types';

export enum RightPanelTab {
  Presets = 'presets',
  Creations = 'creations',
}

export type AppExperience = 'create' | 'landing';

export interface NavigationSlice {
  screen: Screen;
  previousScreen: Screen | null;
  setScreen: (screen: Screen) => void;
  rightPanelTab: RightPanelTab;
  setRightPanelTab: (tab: RightPanelTab) => void;
  presetFeedEntrySlug: string | null;
  setPresetFeedEntrySlug: (presetFeedEntrySlug: string | null) => void;
  feedReturnSlug: string | null;
  setFeedReturnSlug: (feedReturnSlug: string | null) => void;
  isProfileOpen: boolean;
  setIsProfileOpen: (isProfileOpen: boolean) => void;
  /** Settings full-page overlay (portfolio, mobile). Set via setAppStore. */
  isSettingsOpen: boolean;
  /** Credits full-page overlay (portfolio, mobile). Set via setAppStore. */
  isCreditsOpen: boolean;
  profileTab: number;
  hasSeenFeedScrollHint: boolean;
  markFeedScrollHintSeen: () => void;
  appExperience: AppExperience;
}
